import React from 'react'
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout'
import { Heading } from '../../ui/heading/Heading'
import styles from "./contactsSection.module.css"
import { Bar } from "./bar/Bar"
import { MapComponent } from './map/Map'
export function ContactsSection() {
    return (
        <section className={styles.contacts_section}>

            <MarkupLayout>
                <Heading>
                    Контакты
                </Heading>

                <MapComponent></MapComponent>

                <Bar />

            </MarkupLayout>
        </section>
    )
}
